// 预约管理
export default [
  {
    path: "/reserveManage",
    name: "reserveManage",
    meta: { title: "预约管理" },
    component: () => import("../views/reserveManage/index.vue"),
    children: [
      {
        path: "/reserveManage/reserveOrder",
        name: "reserveOrder",
        meta: { title: "预约订单", isMenu: true },
        component: () => import("../views/reserveManage/reserveOrder.vue"),
      },
      {
        path: "/reserveManage/detail/reserveOrderDet",
        name: "reserveOrderDet",
        meta: { title: "预约订单详情" },
        component: () => import("../views/reserveManage/detail/reserveOrderDet.vue"),
      },
    ],
  },
]
